<template>
    <div>
        <div>
            <button @click="collapseNone">Свернуть все</button>
            <button @click="collapseAll">Развернуть все</button>

            <template v-if="isSupport">
                <button @click="downloadPrices">
                    <i class="fa-solid fa-download"></i>&nbsp;Экспорт
                </button>

                <v-loading-component @click="initUpload" ref="importBtn">
                    <template slot-scope="{ loadingClass }">
                        <button :class="[loadingClass]">
                            <i class="fa-solid fa-upload"></i>&nbsp;Импорт
                        </button>
                    </template>
                </v-loading-component>
                <input type="file"
                       id="importFile"
                       style="display: none"
                       :accept="allowedTypes.join(',')"
                       ref="uploadInput"
                       @input="uploadFile"
                />
            </template>
        </div>

        <ImportResultDialog ref="importResults"/>

        <form style="height: calc(100vh - 120px);">
            <div style="height: 100%;">
                <v-loading-component ref="servicesTable">
                    <template slot-scope="{ loadingClass }">
                        <div :class="[{servicesTables: true}, loadingClass]">
                            <template v-for="row in treetable">
                                <h4 @click="toggleVisibility(row.id)" style="cursor:pointer;">
                                    <i class="fa fa-fw fa-chevron-right" v-if="collapsed.indexOf(row.id) === -1"></i>
                                    <i class="fa fa-fw fa-chevron-down" v-else></i>
                                    <b>{{row.name}}</b>
                                    <span>
                                    <small>{{ selectedPricesCount(row) | pluralize('не выбраны услуги', '$ услуга', '$ услуги', '$ услуг') }}</small>
                                </span>
                                </h4>

                                <div :class="'cat_' + row.id" v-if="collapsed.indexOf(row.id) !== -1" style="margin-left: 24px;">
                                    <template v-for="(row1, i1) in row.childs">
                                        <div class="subcategory">
                                            <div class="itemRow hover">
                                                <label class="pricecol1">
                                                    <input type="checkbox"
                                                           :value="true"
                                                           @click.stop.prevent="toggleActive(row1, $event)"
                                                           v-if="!prices[row1.id].active">
                                                    <input type="checkbox"
                                                           :value="true"
                                                           @click.stop.prevent="toggleActive(row1, $event)"
                                                           v-if="prices[row1.id].active"
                                                           checked>
                                                    <v-loading-component :ref="'row' + row1.id">
                                                        <template slot-scope="{ loadingClass }">
                                                            <span :class="loadingClass">
                                                                {{ row1.name }}
                                                            </span>
                                                        </template>
                                                    </v-loading-component>
                                                </label>
                                                <span class="dots"></span>
                                                <input v-model="prices[row1.id].price"
                                                       type="number"
                                                       :class="'pricecol2 price' + row1.id"
                                                       :disabled="!prices[row1.id].active"
                                                       @keydown="disableArrows"
                                                       @change="togglePrice(row1, $event)"
                                                       v-units.literal="`р`" />
                                            </div>
                                            <div v-for="(row2, i2) in row1.childs" class="item">
                                                <div class="itemRow hover">
                                                    <label class="pricecol1">
                                                        <input type="checkbox"
                                                               :value="true"
                                                               @click.stop.prevent="toggleActive(row2, $event)"
                                                               v-if="!prices[row2.id].active">
                                                        <input type="checkbox"
                                                               :value="true"
                                                               @click.stop.prevent="toggleActive(row2, $event)"
                                                               v-if="prices[row2.id].active"
                                                               checked>
                                                        <v-loading-component :ref="'row' + row2.id">
                                                            <template slot-scope="{ loadingClass }">
                                                                <span :class="loadingClass">
                                                                    {{ row2.name }}
                                                                </span>
                                                            </template>
                                                        </v-loading-component>
                                                    </label>
                                                    <span class="dots"></span>
                                                    <input v-model="prices[row2.id].price"
                                                           type="number"
                                                           :class="'pricecol2 price' + row2.id"
                                                           :disabled="!prices[row2.id].active"
                                                           @keydown="disableArrows"
                                                           @change="togglePrice(row2, $event)"
                                                           v-units.literal="`р`" />
                                                </div>
                                                <div v-for="(row3, i3) in row2.childs" class="item">
                                                    <div class="itemRow hover">
                                                        <label class="pricecol1">
                                                            <input type="checkbox"
                                                                   :value="true"
                                                                   @click.stop.prevent="toggleActive(row3, $event)"
                                                                   v-if="!prices[row3.id].active">
                                                            <input type="checkbox"
                                                                   :value="true"
                                                                   @click.stop.prevent="toggleActive(row3, $event)"
                                                                   v-if="prices[row3.id].active"
                                                                   checked>
                                                            <v-loading-component :ref="'row' + row3.id">
                                                                <template slot-scope="{ loadingClass }">
                                                                    <span :class="loadingClass">
                                                                        {{ row3.name }}
                                                                    </span>
                                                                </template>
                                                            </v-loading-component>
                                                        </label>
                                                        <span class="dots"></span>
                                                        <input v-model="prices[row3.id].price"
                                                               type="number"
                                                               :class="'pricecol2 price' + row3.id"
                                                               :disabled="!prices[row3.id].active"
                                                               @keydown="disableArrows"
                                                               @change="togglePrice(row3, $event)"
                                                               v-units.literal="`р`" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </template>
                </v-loading-component>
            </div>
        </form>
    </div>
</template>

<script>
import _ from "lodash";
import ImportResultDialog from "@dialogs/common/ImportResult";

export default {
    components: {
        ImportResultDialog
    },
    props: {
        isSupport: {
            type: Boolean,
            default: false,
        },
        allPrices: {
            type: Object,
            required: true,
        },
        treetable: {
            type: Array,
            required: true,
        },
        clinicId: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            collapsed: JSON.parse(localStorage.getItem(window.location.pathname + '@collapsed')) || [],
            prices: this.allPrices,
            allowedTypes: [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
            ],
        };
    },
    mounted: function () {

    },
    methods: {
        collapseAll: function () {
            let scope = this;
            this.$refs.servicesTable.startLoadingAnimation();

            scope.collapsed = [];

            setTimeout(function () {
                scope.treetable.forEach(function (row) {
                    scope.collapsed.push(row.id);
                });
                scope.$refs.servicesTable.stopLoadingAnimation();
            }, 50);
        },
        collapseNone: function () {
            let scope = this;
            this.$refs.servicesTable.startLoadingAnimation();

            setTimeout(function () {
                scope.collapsed = [];
                scope.$refs.servicesTable.stopLoadingAnimation();
            }, 50);
        },
        toggleVisibility: function (id) {
            if (this.collapsed.indexOf(id) !== -1) {
                this.collapsed = _.without(this.collapsed, id);
            } else {
                this.collapsed.push(id);
            }
            localStorage.setItem(window.location.pathname + '@collapsed', JSON.stringify(this.collapsed));
        },
        selectedPricesCount: function (row) {
            let scope = this;
            let count = 0;
            row.childIds.forEach(function (id) {
                if (scope.prices[id].active === true) {
                    count++;
                }
            });
            return count;
        },
        toggleActive: function (row, e) {
            this.prices[row.id].active = !this.prices[row.id].active;
            this.$refs['row' + row.id][0].startLoadingAnimation();
            let item = this.prices[row.id];

            if (item.active) {
                // отмечаем всех детей
                for (let childId of row.childIds) {
                    this.prices[childId].active = true;
                }

                // отмечаем всех родителей
                for (let parentId of row.parentIds) {
                    this.prices[parentId].active = true;
                }

            } else {
                // снимаем отметку у всех детей
                for (let childId of row.childIds) {
                    this.prices[childId].active = false;
                }

                // проверяем, есть ли вложенные галочки у рутов
                if (row.depth === 1) {
                    for (let rootEl of this.treetable) {
                        if (rootEl.childIds.includes(row.id)) {
                            let hasActiveChild = false;
                            for (let id of rootEl.childIds) {
                                if (this.prices[id].active === true) {
                                    hasActiveChild = true;
                                }
                            }
                            this.prices[rootEl.id].active = hasActiveChild;
                        }
                    }
                }
            }

            this.axios.post('services/update', {clinic_id: this.clinicId, prices: this.prices})
                .then((response) => {
                    this.$refs['row' + row.id][0].stopLoadingAnimation();
                });
        },
        disableArrows(e) {
            if (e.code === 'ArrowUp' || e.code === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        togglePrice: function (row, e) {
            this.prices[row.id].price = this.prices[row.id].price.replaceAll('-', '').replaceAll('+', '');
            document.querySelector('input.price' + row.id).value = this.prices[row.id].price;
            document.querySelector('input.price' + row.id).classList.add('loading');

            let item = this.prices[row.id];
            this.axios.post('services/updatePrice', {clinic_id: this.clinicId, id: row.id, price: item.price})
                .then((response) => {
                    document.querySelector('input.price' + row.id).classList.remove('loading');
                });
        },
        downloadPrices: function () {
            this.$refs.servicesTable.startLoadingAnimation();

            this.axios.post('services/downloadPricelist/' + (this.clinicId ?? ''))
                .then((response) => {
                    this.downloadXLSX(response.data.data, response.data.filename);
                    this.$refs.servicesTable.stopLoadingAnimation();
                });
        },
        downloadXLSX(base64Data, name) {
            const blob = new Blob([this.base64toBlob(base64Data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')], {});

            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = name + '.xlsx'
            link.click()
            URL.revokeObjectURL(link.href)
        },
        base64toBlob(base64Data, contentType) {
            contentType = contentType || '';
            const sliceSize = 1024;
            const byteCharacters = atob(base64Data);
            const bytesLength = byteCharacters.length;
            const slicesCount = Math.ceil(bytesLength / sliceSize);

            let byteArrays = new Array(slicesCount);
            for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                let begin = sliceIndex * sliceSize;
                let end = Math.min(begin + sliceSize, bytesLength);

                let bytes = new Array(end - begin);
                for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArrays[sliceIndex] = new Uint8Array(bytes);
            }

            return new Blob(byteArrays, {type: contentType});
        },
        initUpload: function () {
            document.querySelector('#importFile').click();
        },
        uploadFile: function (e) {
            if (e.target.files.length) {
                this.$refs.importBtn.startLoadingAnimation();

                let formData = new FormData();
                formData.append('pricelist', e.target.files[0]);

                this.axios.post('services/updatePricelist/' + (this.clinicId ?? ''), formData)
                    .then((response) => {
                        this.$refs.importBtn.stopLoadingAnimation();
                        this.$refs.importResults.show(response.data.result, response.data.errors)
                    }, () => {
                        this.$refs.importBtn.stopLoadingAnimation();
                    });
            }
        },
        initUploader: function ($el) {
            let scope = this;
            $el.uploadFile({
                multiple: false,
                allowedTypes: '.xlsx',
                maxFileCount: 1,
                fileName: 'pricelist',
                onSubmit: function () {
                    this.url = 'services/updatePricelist/' + (scope.clinicId ?? '');
                },
                onSelect: function (files) {
                    if ($.inArray('.' + getFileExtention(files[0].name), this.allowedTypes.toLowerCase().split(', ')) < 0) {
                        alert('Запрещено загружать файлы этого типа (' + getFileExtention(files[0].name) + ')');
                        return false;
                    }
                    return true;
                },
                onSuccess: function (files, data, xhr) {
                    scope.$refs.importResults.show(data.result, data.error)
                },
                onError: function (files, status, errMsg) {
                    alert('Ошибка: ' + files);
                    console.error("Ошибка:", files);
                }
            });
        },
    },
    watch: {
        allPrices(newVal) {
            this.prices = newVal;
        }
    },
}
</script>

<style scoped>
input[type="checkbox"][checked] {
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z'/></svg>");
}
input[type="checkbox"]:not([checked]) {
    background-image: none;
}
</style>

<style>
.servicesTables {
    overflow: auto;
    width: 100%;
    padding-right: 10px;
}
.servicesTables.loading {
    height: calc(100% - 30px);
}
.servicesTables > div {
    column-width: 450px;
}
.servicesTables > div.cat_666 {
    column-width: auto !important;
}
.servicesTables .subcategory {
    break-inside: avoid;
    break-after: auto;
}
.servicesTables .item {
    break-inside: avoid;
    margin-left: 30px;
}
.servicesTables input {
    text-align: right;
}
.servicesTables input:disabled {
    opacity: 0.2;
}
.servicesTables .itemRow {
    display: grid;
    grid: "name dots info";
    grid-template-columns: auto 1fr auto;
}
.servicesTables .itemRow .dots {
    display: inline-block;
    width: auto;
    border-bottom: 1px dotted #c0c0c0;
    margin: 0 5px 4px;
}
.servicesTables .itemRow input.pricecol2 {
    width: 70px;
}
</style>
